import { useState } from "react";
import { LockSimple, ArrowRight } from "@phosphor-icons/react";
import { ProBadge } from "@/components/ProBadge";
import { detectCurrency, PRICES, fmt, startCheckout } from "@/lib/billing";

export function ProLock({ feature, desc, testId = "pro-lock" }) {
  const [busy, setBusy] = useState(null);
  const cur = detectCurrency();
  const p = PRICES[cur];

  const go = async (plan) => {
    setBusy(plan);
    await startCheckout(plan);
    setBusy(null);
  };

  return (
    <div className="clay p-8 text-center" data-testid={testId}>
      <div className="w-12 h-12 rounded-2xl bg-brand/10 flex items-center justify-center mx-auto">
        <LockSimple size={22} weight="fill" color="var(--brand)" />
      </div>
      <h3 className="font-display text-xl font-medium mt-4 flex items-center justify-center gap-2">
        {feature} <ProBadge testId={`${testId}-badge`} />
      </h3>
      <p className="text-sm text-muted2 mt-2 max-w-sm mx-auto leading-relaxed">
        {desc || "Your 7-day Pro trial has ended. Upgrade to keep the full operating system."}
      </p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
        <button
          data-testid={`${testId}-monthly-btn`}
          disabled={!!busy}
          onClick={() => go("monthly")}
          className="bg-brand text-white rounded-full px-6 py-3 text-sm font-medium hover:bg-ink hover:text-bg transition-colors disabled:opacity-60"
        >
          {busy === "monthly" ? "Opening checkout…" : <>First month {fmt(p.intro, cur)}, then {fmt(p.monthly, cur)}/mo</>}
        </button>
        <button
          data-testid={`${testId}-annual-btn`}
          disabled={!!busy}
          onClick={() => go("annual")}
          className="border border-border rounded-full px-6 py-3 text-sm font-medium hover:bg-secondary transition-colors inline-flex items-center justify-center gap-1.5 disabled:opacity-60"
        >
          {busy === "annual" ? "Opening checkout…" : <>{fmt(p.annual, cur)}/year — 2 months free <ArrowRight size={14} weight="bold" /></>}
        </button>
      </div>
      <p className="text-[11px] text-muted2 mt-4">Cancel anytime. Safety features always stay free.</p>
    </div>
  );
}

export function trialDaysLeft(entitlement) {
  if (!entitlement?.trial_active || !entitlement.trial_ends_at) return null;
  const ms = new Date(entitlement.trial_ends_at) - new Date();
  return Math.max(1, Math.ceil(ms / 86400000));
}
